const translations = {
    closeSidebar: 'Close Sidebar',
    home: 'Home',
    org: 'Org'
};

export default translations;
